<template><div><h1>VUX V2.7.7 发布日志</h1>
<h2><a href="/zh-CN/components/popup-picker.html">PopupPicker</a></h2>
<ul><li>[fix] 去除第一个子元素的上边线 #2371</li>
</ul>
<h2><a href="/zh-CN/components/sticky.html">Sticky</a></h2>
<ul><li>[fix] 修复定位不准确和定位无效的问题 #2367</li>
</ul>
<h2><a href="/zh-CN/components/swiper.html">Swiper</a></h2>
<ul><li>[fix] 修复只有一个 item 时无法滚动页面的问题</li>
</ul>
<h2><a href="/zh-CN/components/tabbar.html">Tabbar</a></h2>
<ul><li>[fix] 修复 tabbar-item 服务端渲染不一致问题</li>
</ul>
<h2><a href="/zh-CN/components/toast.html">Toast</a></h2>
<ul><li>[fix] 插件 options 参数作为toast的默认参数</li>
</ul>
<h2><a href="/zh-CN/components/x-input.html">XInput</a></h2>
<ul><li>[fix] 修复报错信息不会改变的问题 #2348</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.7.7 发布日志 | VUX - 基于 WeUI 和 Vue 的移动端组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.7.7-270.vue?0640945a